(function () {
  'use strict';
  /* jp-comucare-sticky 2026-08-21 */

  /* ------------------------------------------------------------------
     「加入购物车」按钮：AJAX 加购并打开主题原生购物车抽屉。
     忠实复刻 theme.js 里 ProductForm 的事件流（cart:prepare-bundled-sections
     → cart/add.js(带 sections) → cart.js → variant:add + cart:change），
     由 <cart-drawer> 自己 .show()/刷新，不手动改 open 属性。
     ------------------------------------------------------------------ */
  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function cartType() {
    return (
      (window.themeVariables &&
        window.themeVariables.settings &&
        window.themeVariables.settings.cartType) ||
      'drawer'
    );
  }

  function selectedCareVariantId() {
    var checked = document.querySelector('[data-comu-care-option]:checked');
    return checked ? checked.dataset.variantId : null;
  }

  function parseCartAddResponse(response) {
    return response.text().then(function (raw) {
      var json = null;
      try {
        json = JSON.parse(raw);
      } catch (parseError) {
        json = { description: raw.replace(/\s+/g, ' ').slice(0, 120) };
      }
      return { ok: response.ok, json: json };
    });
  }

  function addToCartAndReveal(variantId, quantity) {
    var root = cartRoot();
    var careId = selectedCareVariantId();
    var qty = quantity || 1;

    // 勾选延保时交给购买区同一条 submitWithCare，避免吸底栏自己拼 items[]
    // 再次踩上「套餐+延保被 Kaching 拆成多次加购 → 429」。
    if (careId) {
      var form =
        document.querySelector('.product-info__buy-buttons form[is="product-form"]') ||
        document.querySelector('form[is="product-form"]');
      if (form) {
        return new Promise(function (resolve) {
          var settled = false;
          function done() {
            if (settled) return;
            settled = true;
            document.removeEventListener('cart:change', done);
            document.removeEventListener('cart:error', done);
            form.removeEventListener('cart:error', done);
            resolve();
          }
          document.addEventListener('cart:change', done);
          document.addEventListener('cart:error', done);
          form.addEventListener('cart:error', done);
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else {
            var submitBtn = form.querySelector('[type=submit]');
            if (submitBtn) submitBtn.click();
            else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
          setTimeout(done, 10000);
        });
      }
    }

    // 让 <cart-drawer> 把自身 section id 推入待返回列表（与 ProductForm 一致）
    var bundledSections = ['variant-added'];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: bundledSections }
      })
    );

    var formData = new FormData();
    formData.set('id', variantId);
    formData.set('quantity', qty);
    formData.set('sections', bundledSections.join(','));
    formData.set('sections_url', root + 'variants/' + variantId);
    var request = fetch(root + 'cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    return request
      .then(parseCartAddResponse)
      .then(function (result) {
        if (!result.ok) {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          throw new Error((result.json && (result.json.description || result.json.message)) || 'cart add failed');
        }
        return result;
      })
      .then(function (result) {
        if (cartType() === 'page') {
          window.location.href = root + 'cart';
          return;
        }

        return fetch(root + 'cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            cart.sections = result.json.sections;
            var items = result.json.items || [result.json];

            /* variant:add 触发抽屉 .show()（drawer 模式）或加购通知（popover 模式） */
            document.documentElement.dispatchEvent(
              new CustomEvent('variant:add', {
                bubbles: true,
                detail: { items: items, cart: cart }
              })
            );
            /* cart:change 刷新抽屉内容 */
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:change', {
                bubbles: true,
                detail: { baseEvent: 'variant:add', cart: cart }
              })
            );
          });
      });
  }

  function bindStickyAddToCart() {
    if (window.__comuStickyAddBound) return;
    window.__comuStickyAddBound = true;

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-comu-sticky-add]');
      if (!btn) return;

      event.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true') return;

      var variantId = btn.getAttribute('data-variant-id');
      var quantity = parseInt(btn.getAttribute('data-quantity'), 10) || 1;
      var fallbackHref = btn.getAttribute('href');

      if (!variantId) {
        if (fallbackHref) window.location.href = fallbackHref;
        return;
      }

      btn.setAttribute('aria-busy', 'true');
      addToCartAndReveal(variantId, quantity)
        .then(function () {
          btn.removeAttribute('aria-busy');
        })
        .catch(function () {
          btn.removeAttribute('aria-busy');
          if (fallbackHref) window.location.href = fallbackHref;
        });
    });
  }

  var drawerSyncCallbacks = [];
  var drawerSyncReady = false;

  function initDrawerSync(onChange) {
    drawerSyncCallbacks.push(onChange);

    function notify(isOpen) {
      drawerSyncCallbacks.forEach(function (callback) {
        callback(isOpen);
      });
    }

    function bindCartDrawer(cartDrawer) {
      if (!cartDrawer || cartDrawer.dataset.comuStickyDrawerBound === 'true') return false;
      cartDrawer.dataset.comuStickyDrawerBound = 'true';

      if ('MutationObserver' in window) {
        var observer = new MutationObserver(function () {
          notify(cartDrawer.hasAttribute('open'));
        });
        observer.observe(cartDrawer, { attributes: true, attributeFilter: ['open'] });
      }

      notify(cartDrawer.hasAttribute('open'));
      return true;
    }

    if (!drawerSyncReady) {
      drawerSyncReady = true;

      document.addEventListener('dialog:after-show', function (event) {
        if (event.target && event.target.id === 'cart-drawer') notify(true);
      });
      document.addEventListener('dialog:after-hide', function (event) {
        if (event.target && event.target.id === 'cart-drawer') notify(false);
      });

      document.addEventListener('shopify:section:load', function (event) {
        var cartDrawer = event.target.querySelector('#cart-drawer') || document.getElementById('cart-drawer');
        if (bindCartDrawer(cartDrawer) && cartDrawer) {
          notify(cartDrawer.hasAttribute('open'));
        }
      });
    }

    bindCartDrawer(document.getElementById('cart-drawer'));
  }

  function initStickyVisibility(root) {
    var hideAtFooter = root.getAttribute('data-hide-at-footer') === 'true';
    var displayMode = root.getAttribute('data-display-mode') || 'after_scroll';

    var showAfter = parseInt(root.getAttribute('data-show-after'), 10);
    if (isNaN(showAfter)) showAfter = 0;

    var heroVisible;
    var footerVisible = false;
    var drawerOpen = false;
    var stickyVisible = null;

    function applyVisibility() {
      var shouldShow = !heroVisible && !footerVisible && !drawerOpen;

      root.classList.toggle('is-hidden-by-drawer', drawerOpen);

      if (stickyVisible !== shouldShow) {
        stickyVisible = shouldShow;

        if (shouldShow) {
          root.classList.remove('is-hidden-by-hero', 'is-hidden-by-footer');
          document.body.classList.add('comu-has-sticky-bar');
        } else {
          root.classList.toggle('is-hidden-by-hero', heroVisible);
          root.classList.toggle('is-hidden-by-footer', !heroVisible && footerVisible);
          /* 抽屉打开时保留 padding-bottom，避免关抽屉时页面跳动 */
          if (!drawerOpen) {
            document.body.classList.remove('comu-has-sticky-bar');
          }
        }
      }
    }

    initDrawerSync(function (isOpen) {
      if (drawerOpen === isOpen) return;
      drawerOpen = isOpen;
      applyVisibility();
    });

    function observeTarget(target, onChange) {
      if (!target) return;

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              onChange(entry.isIntersecting);
            });
          },
          {
            threshold: 0,
            rootMargin: '0px 0px -1px 0px'
          }
        );
        observer.observe(target);
        return;
      }

      function onScroll() {
        var rect = target.getBoundingClientRect();
        onChange(rect.top < window.innerHeight && rect.bottom > 0);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }

    if (displayMode === 'always_visible') {
      heroVisible = false;
    } else {
      /* 「首屏参照物」：只要它还在视口里，就说明用户还没往下滑，吸底栏保持隐藏。
         原来只认 comu-hero 的按钮组——预热页有、商品页没有，
         于是商品页 heroActions 为 null，直接判定「已离开首屏」，一进页面就弹出来。
         这里按优先级依次找：
           1. comu-hero 的按钮组（预热页/首页，行为与以前完全一致）
           2. 商品页购买区的加购按钮（吸底栏本来就是它滚走之后的替身）
           3. 都没有 → 退回滚动阈值（data-show-after 像素） */
      var anchorSelectors = [
        '.shopify-section--comu-hero .hero-actions',
        '[data-comu-hero-actions]',
        '.product-info__buy-buttons',
        '.product-info buy-buttons'
      ];
      var heroActions = null;
      for (var ai = 0; ai < anchorSelectors.length; ai++) {
        heroActions = document.querySelector(anchorSelectors[ai]);
        if (heroActions) break;
      }

      heroVisible = Boolean(heroActions);

      if (heroActions) {
        /* 判据是「参照物有没有从上方滚走」，不是「参照物可不可见」。
           两者在预热页等价（hero 就在页顶），但在商品页完全不同：
           加购按钮本来就不在首屏，用「可见才隐藏」会得到
           「首屏显示 → 滚到按钮时隐藏 → 滚过又显示」的反向行为。
           rect.bottom > 0 == 参照物底边还没越过视口顶部 == 用户还没滑过它 → 保持隐藏。 */
        var onAnchorScroll = function () {
          var rect = heroActions.getBoundingClientRect();
          var notPassed = rect.bottom > 0;
          if (heroVisible === notPassed) return;
          heroVisible = notPassed;
          applyVisibility();
        };
        window.addEventListener('scroll', onAnchorScroll, { passive: true });
        window.addEventListener('resize', onAnchorScroll);
        onAnchorScroll();
      } else if (showAfter > 0) {
        /* 没有任何参照物时的兜底：滚动超过设定像素才显示 */
        heroVisible = true;
        var onScrollThreshold = function () {
          var past = (window.pageYOffset || document.documentElement.scrollTop) >= showAfter;
          if (heroVisible === !past) return;
          heroVisible = !past;
          applyVisibility();
        };
        window.addEventListener('scroll', onScrollThreshold, { passive: true });
        window.addEventListener('resize', onScrollThreshold);
        onScrollThreshold();
      } else {
        heroVisible = false;
      }
    }

    if (hideAtFooter) {
      var footerTarget = document.querySelector('.shopify-section--footer');
      observeTarget(footerTarget, function (isIntersecting) {
        footerVisible = isIntersecting;
        applyVisibility();
      });
    }

    applyVisibility();
  }

  function detectPriceFormat(text) {
    var s = String(text || '');
    if (/,\d{2}\b/.test(s) && !/\.\d{2}\b/.test(s)) {
      if (/\d[\s ]\d/.test(s)) return { decimal: ',', thousands: ' ' };
      return { decimal: ',', thousands: '.' };
    }
    return { decimal: '.', thousands: ',' };
  }

  function parsePriceText(text) {
    if (!text) return 0;
    var cleaned = String(text).replace(/[^\d.,]/g, '').trim();
    if (!cleaned) return 0;
    var fmt = detectPriceFormat(cleaned);
    if (fmt.decimal === ',') {
      if (/,\d{1,2}$/.test(cleaned)) {
        return Math.round(parseFloat(cleaned.replace(/\./g, '').replace(',', '.')) * 100);
      }
      return parseInt(cleaned.replace(/[.,]/g, ''), 10) || 0;
    }
    if (/\.\d{1,2}$/.test(cleaned)) {
      return Math.round(parseFloat(cleaned.replace(/,/g, '')) * 100);
    }
    return parseInt(cleaned.replace(/,/g, ''), 10) || 0;
  }

  function formatPriceLike(sample, amount) {
    var fmt = detectPriceFormat(sample);
    var hasDecimals = fmt.decimal === ','
      ? /,\d{2}\b/.test(sample || '')
      : /\.\d{2}\b/.test(sample || '');
    var formatted;
    if (hasDecimals) {
      var num = (amount / 100).toFixed(2);
      var parts = num.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, fmt.thousands);
      formatted = parts[0] + fmt.decimal + parts[1];
    } else {
      formatted = String(Math.round(amount)).replace(/\B(?=(\d{3})+(?!\d))/g, fmt.thousands);
    }
    if (sample && /[\d]/.test(sample)) return sample.replace(/\d[\d.,\s ]*\d|\d/, formatted);
    return formatted;
  }

  function visiblePriceText(el) {
    if (!el) return '';
    var clone = el.cloneNode(true);
    Array.prototype.forEach.call(clone.querySelectorAll('.sr-only'), function (node) {
      node.remove();
    });
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  function getProductPriceEl(kind) {
    var kachingBar = document.querySelector('.kaching-bundles__bar--selected');
    if (kachingBar) {
      if (kind === 'compare') {
        return kachingBar.querySelector('.kaching-bundles__bar-full-price');
      }
      return kachingBar.querySelector('.kaching-bundles__bar-price');
    }

    var scope = document.querySelector('.product-info');
    if (!scope) return null;
    if (kind === 'compare') {
      return (
        scope.querySelector('.product-info__price [data-kaching-price-compare]') ||
        scope.querySelector('.product-info__price compare-at-price')
      );
    }
    return (
      scope.querySelector('.product-info__price [data-kaching-price]') ||
      scope.querySelector('.product-info__price sale-price')
    );
  }

  function selectedCarePrice() {
    var checked = document.querySelector('[data-comu-care-option]:checked');
    if (!checked) return 0;
    var label = checked.closest('label');
    var visible = label && label.querySelector('.comu-care__price');
    if (visible) return parsePriceText(visible.textContent);
    return 0;
  }

  function updateStickyPrice(root) {
    var wrap = root.querySelector('[data-comu-sticky-price]');
    if (!wrap) return;

    var nowEl = wrap.querySelector('.sticky-price-now');
    var wasEl = wrap.querySelector('.sticky-price-was');
    if (!nowEl) return;

    var buyNowEl = getProductPriceEl('now');
    var buyWasEl = getProductPriceEl('compare');

    var bundleNow =
      parsePriceText(visiblePriceText(buyNowEl)) ||
      parsePriceText(nowEl.textContent);

    var bundleWas =
      parsePriceText(visiblePriceText(buyWasEl)) ||
      (wasEl && parsePriceText(wasEl.textContent)) ||
      0;

    var care = selectedCarePrice();
    var now = bundleNow + care;
    var was = bundleWas > bundleNow ? bundleWas + care : 0;
    var sample = visiblePriceText(buyNowEl) || nowEl.textContent;

    nowEl.textContent = formatPriceLike(sample, now);
    wrap.classList.toggle('is-on-sale', was > now);

    if (wasEl) {
      if (was > now) {
        wasEl.hidden = false;
        wasEl.textContent = formatPriceLike(
          visiblePriceText(buyWasEl) || wasEl.textContent || sample,
          was
        );
      } else {
        wasEl.hidden = true;
      }
    }
  }

  function initStickyPrice(root) {
    if (root.dataset.comuStickyPriceReady === 'true') return;
    if (!root.querySelector('[data-comu-sticky-price]')) return;
    root.dataset.comuStickyPriceReady = 'true';

    var scheduled = null;
    function schedule() {
      if (scheduled) return;
      scheduled = requestAnimationFrame(function () {
        scheduled = null;
        updateStickyPrice(root);
      });
    }

    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches('[data-comu-care-option]')) schedule();
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('[class*="kaching"], kaching-bundles-block, kaching-bundles-bar')) {
        schedule();
        setTimeout(schedule, 80);
        setTimeout(schedule, 240);
      }
    });

    var priceRoot = document.querySelector('.product-info .product-info__price');
    if ('MutationObserver' in window && priceRoot) {
      var observer = new MutationObserver(schedule);
      observer.observe(priceRoot, { childList: true, subtree: true, characterData: true });
    }

    var kachingRoot = document.querySelector('.kaching-bundles__bars');
    if ('MutationObserver' in window && kachingRoot) {
      var kachingObserver = new MutationObserver(schedule);
      kachingObserver.observe(kachingRoot, { childList: true, subtree: true, attributes: true, characterData: true });
    }

    schedule();
    setTimeout(schedule, 400);
  }

  function initStickyBar(root) {
    if (!root || root.dataset.comuStickyBarReady === 'true') return;

    initStickyVisibility(root);
    initStickyPrice(root);
    root.dataset.comuStickyBarReady = 'true';
  }

  function boot() {
    bindStickyAddToCart();
    document.querySelectorAll('[data-comu-sticky-bar]').forEach(initStickyBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
